<i18n>
{
  "fr": {

  },
  "de": {

  }
}
</i18n>

<template>

  <div id="timeframe-selector">
    <div id='timeline' v-if="events.length > 0"></div>
  </div>

</template>

<script>

import * as d3 from 'd3'
import _ from 'lodash'
import TimeMixin from '@/mixins/store/time'
import timeline from './graph/timeline'

export default {
  name: 'TimeframeSelector',
  mixins: [
    TimeMixin
  ],
  props: {
    enableZoom: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      timescaleDebounce: null,
      timeline: null,
      timelineChart: null,
      timelineEvents: []
    }
  },
  watch: {
    events () {
      this.updateGraph()
    }
  },
  mounted () {
    this.timeline = timeline({
        widthResizable: true,
        viewHeight: 200,
        margin: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        enableZoom: this.enableZoom,
        onTimescaleChange: this.onTimescaleChange,
        onMouseOver: this.onMouseOver
      })
    this.updateGraph()
  },
  methods: {
    onTimescaleChange (domain) {
      clearTimeout(this.timescaleDebounce)
      this.timescaleDebounce = setTimeout(() => {
        this.setTimeframe(domain)
      }, 250)
    },
    onMouseOver (timestamp) {
      this.$emit('mouseover', timestamp)
    },
    updateGraph () {
      this.timelineEvents = _.clone(this.events)
      this.draw()
    },
    draw () {
      this.timelineChart = d3.select('#timeline')
        .datum(this.timelineEvents)
        .call(this.timeline)
    },
    moveTo (domain) {
      this.$nextTick(() => {
        this.timeline.moveTo(domain)
      })
    },
    reset () {
      this.timeline.reset()
    }
  }
}
</script>

<style scoped>
  #timeline {
    width: 100%
  }
</style>